import { render, staticRenderFns } from "./Prepago.vue?vue&type=template&id=98f2d82e&scoped=true"
import script from "./Prepago.vue?vue&type=script&lang=js"
export * from "./Prepago.vue?vue&type=script&lang=js"
import style0 from "./Prepago.vue?vue&type=style&index=0&id=98f2d82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f2d82e",
  null
  
)

export default component.exports